<template>
    <div>
        <div class="step-box">
            <step titleColor="green">
                <p slot="title">Step 1</p>
                <p slot="text">Select an existing or create a new Diet or skip by entering your own Phytate-P value.</p>
            </step>
            <div class="flex flex-col items-center justify-around">
                <div class="flex flex-wrap items-center justify-center my-5 w-4/5 sm:w-3/5">
                    <div
                        class="relative inline-block flex-grow mx-2"
                        v-if="diets && Object.keys(diets).length > 0"
                    >
                        <select
                            v-model="selectedDietId"
                            @change="dietSelected"
                            class="appearance-none btn-large w-full bg-white text-grey-darker pr-8 leading-tight focus:outline-none cursor-pointer"
                            id="grid-state"
                        >
                            <option
                                disabled
                                value=""
                            >
                                Please select a Diet
                            </option>
                            <option
                                v-for="curDiet in diets"
                                :key="curDiet.id"
                                :value="curDiet.id"
                            >{{curDiet.name}}</option>
                        </select>
                        <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                            <svg
                                class="fill-current h-4 w-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                            >
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                    <!-- <div class="">
                    <button class="bg-transparent hover:bg-blue text-blue-dark font-semibold hover:text-white py-2 px-4 mx-2 my-4 border border-blue hover:border-transparent rounded">
                    Manage Diets
                    </button>
                </div> -->
                    <div class="text-center flex-none">
                        <button
                            class="btn btn-large btn-success mx-2 my-4 inline-flex items-center"
                            @click="showCreateDiet = true"
                        >
                            <span>Create new Diet</span>
                            <span class="icon is-small ml-1">
                                <i class="ti-plus"></i>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="self-stretch strike">
                    <span>or</span>
                </div>
                <div class="text-center flex-grow my-5 w-4/5">
                    <button
                        class="btn-large btn-primary mx-2 my-4 inline-flex items-center"
                        @click="usePhytateValue"
                    >
                        Skip this step and Enter Phytate-P
                    </button>
                </div>
            </div>
        </div>
        <div id="feed-step2">
            <transition
                name="fade"
                v-on:enter="scrollToId('feed-step2')"
            >
                <div
                    id="feed-step2-ingredients"
                    class="step-box"
                    v-show="step2View == 'diet'"
                >
                    <step titleColor="orange">
                        <p slot="title">Step 2</p>
                        <p slot="text">Edit your diet for Phytate-P calculation</p>
                    </step>
                    <div class="flex justify-center">
                        <div class="flex self-center flex-col py-1 px-2 sm:py-5 sm:px-10 w-full md:w-full lg:w-3/4">
                            <div class="md:flex md:items-center mb-5">
                                <div class="md:w-1/4">
                                    <label
                                        class="md:text-right pr-4 tracking-wide block text-grey-darker text-xs sm:text-sm md:text-base font-semibold mb-1 md:mb-0"
                                        for="matrixName"
                                    >
                                        Diet name
                                    </label>
                                </div>
                                <div class="md:w-3/4">
                                    <input
                                        v-model="diet.name"
                                        @input="diet.edited = true"
                                        class="shadow appearance-none rounded w-full py-3 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                                        id="matrixName"
                                        type="text"
                                        placeholder="Example diet..."
                                        aria-label="Diet name"
                                    >
                                </div>
                            </div>
                            <div class="">
                                <table class="table diet-table w-full shadow rounded text-sm sm:text-base md:text-lg text-grey-darker">
                                    <tbody>
                                        <tr
                                            v-for="(row, index) in diet.ingredients"
                                            :key="row.name"
                                        >
                                            <td
                                                class="w-1/2 md:w-2/3 align-middle"
                                                v-if="row.editable==false"
                                                v-text="row.name"
                                                @click="row.editable=true"
                                            ></td>
                                            <td v-else>
                                                <span class="select">
                                                    <select
                                                        @change="pushIngredientToDiet(row,$event)"
                                                        @blur="row.editable=false"
                                                        v-model="row.name"
                                                    >
                                                        <option
                                                            value="Select ingredient"
                                                            disabled
                                                            selected
                                                        >Select ingredient</option>
                                                        <option
                                                            v-for="ingredient in ingredientsArray"
                                                            v-text="ingredient.name"
                                                            :key="ingredient.name"
                                                        ></option>
                                                    </select>
                                                </span>
                                            </td>
                                            <td class="w-1/2 md:w-1/3">
                                                <div class="flex justify-end items-center">
                                                    <div class="field has-addons mb-0">
                                                        <p class="control">
                                                            <input
                                                                class="input pctg"
                                                                type="number"
                                                                @click="removeZero(row)"
                                                                @blur="addZero(row)"
                                                                v-model="row.percentage"
                                                                @keyup="ingredientInclusionEntered(row,$event)"
                                                                @input="diet.edited = true; calculatePhytase();"
                                                            >
                                                        </p>
                                                        <p class="control">
                                                            <a class="button is-static">
                                                                %
                                                            </a>
                                                        </p>
                                                    </div>
                                                    <button @click="diet.ingredients.splice(index,1); diet.edited = true;" class="ml-6 flex items-center text-red hover:text-red-darker w-6 h-6">
                                                        <span class="inline-flex justify-center items-center text-sm">
                                                                <i class="ti-close"></i>
                                                        </span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="bg-grey-lightest">
                                            <td>
                                                <a
                                                    class="button"
                                                    @click="addRow"
                                                >
                                                    <span class="icon">
                                                        <i class="fa fa-plus-circle"></i>
                                                    </span>
                                                    <span>Add ingredient</span>
                                                </a>
                                            </td>
                                            <td />
                                        </tr>
                                        <tr class="bg-grey-lightest">
                                            <td>TOTAL</td>
                                            <td class="pctgCol">
                                                <div class="field has-addons">
                                                    <p class="control">
                                                        <input
                                                            class="input pctg"
                                                            :class="totalPctg > 100 || totalPctg <= 0 ? 'is-danger' : ''"
                                                            type="number"
                                                            v-model="totalPctg"
                                                            readonly
                                                        >
                                                    </p>
                                                    <p class="control">
                                                        <a class="button is-static">
                                                            %
                                                        </a>
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="bg-grey-lightest font-bold">
                                            <td>Dietary Phytate P in %</td>
                                            <td
                                                class="pctgCol"
                                                v-text="roundedPhytate"
                                            ></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <div class="flex justify-center w-full">
                                                    <button
                                                        class="btn btn-delete mx-2 inline-flex items-center shadow-none hover:font-medium"
                                                        @click="showDeleteModal = true"
                                                    >
                                                        <span>Delete Diet</span>
                                                        <span class="icon is-small">
                                                            <i class="ti-trash"></i>
                                                        </span>
                                                    </button>
                                                    <button
                                                        :class="{ 'btn-disabled': !diet.edited }"
                                                        class="btn btn-primary mx-2 inline-flex items-center"
                                                        @click="handleSaveDiet"
                                                        :disabled="!diet.edited"
                                                    >
                                                        <span>Save Diet</span>
                                                        <span class="icon is-small ml-1">
                                                            <i class="ti-save"></i>
                                                        </span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="text-xs sm:text-sm text-grey-darker pt-2 px-2">
                                <span class="font-medium text-xs text-grey tracking-wide">SOURCES</span>
                                <div class="leading-tight">
                                    <ul class="list-disc pl-4">
                                        <li>DSM</li>
                                        <li>CVB Feed Table 2018</li>
                                        <li>Tables of composition and nutritional value of feed materials, INRA,2004</li>
                                        <li>FEDNA 2016</li>
                                        <li>Brazilian Tables for Poultry and Swine, 2017</li>
                                        <li>International Aquaculture Feed Formulation Database, 2019</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <transition
                name="fade"
                v-on:enter="scrollToId('feed-step2')"
            >
                <div
                    class="step-box"
                    v-show="step2View == 'phytate'"
                >
                    <step titleColor="orange">
                        <p
                            slot="title"
                            class="step-title"
                        >Step 2</p>
                        <p slot="text">Enter Phytate-P value</p>
                    </step>
                    <div class="column is-8 is-offset-2">
                        <div class="column is-8 is-offset-2">
                            <div class="field has-addons">
                                <p class="control is-expanded">
                                    <input
                                        class="input btn-medium-text-normal"
                                        @input="$emit('update:phytate', {'phytate': totalPhytase});"
                                        v-model="totalPhytase"
                                        type="number"
                                        step="0.001"
                                        placeholder="Enter Dietary Phytate-P value here"
                                    >
                                </p>
                                <p class="control">
                                    <a class="button is-medium is-static">
                                        %
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <custom-modal
            :isFullHeight="true"
            :showModal="showCreateDiet"
            v-on:update:showModal="data => showCreateDiet = data"
            @submit="createLocalDiet"
            title="Create new Diet"
        >
            <div
                slot="body-top"
                class="customSection section"
            >
                <div class="">
                    <div class="">
                        <label
                            class="pr-4 tracking-wide block text-grey-darker text-xs sm:text-sm md:text-base font-semibold mb-1"
                            for="matrixName"
                        >
                            Diet name
                        </label>
                    </div>
                    <div class="">
                        <input
                            v-model="dietName"
                            class="shadow appearance-none rounded border w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="Example diet..."
                            aria-label="Diet name"
                        >
                    </div>
                </div>
            </div>
            <div
                slot="body"
                class=""
            >
                <div class="tracking-wide mb-1 text-grey-darker text-xs sm:text-sm md:text-base font-semibold">Select all the ingredients to be included in the diet</div>
                <multiselect
                    v-model="selectedIngredients"
                    :option-height="10"
                    :close-on-select="false"
                    :options="ingredients"
                    :multiple="true"
                    group-values="options"
                    group-label="category"
                    :group-select="false"
                    placeholder="Type to search"
                    track-by="name"
                    label="name"
                    class="shadow rounded"
                >
                    <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                </multiselect>
            </div>
        </custom-modal>
        <custom-modal
            :showModal="showDeleteModal"
            title="Delete Diet?"
            @update:showModal="data => showDeleteModal = data"
            :submitBtn="{text:'Delete', type:'danger'}"
            @submit="() => {showDeleteModal = false; deleteDiet()}"
        >
            <div slot="body">
                <p>Are you sure you want to delete this diet?</p>
            </div>
        </custom-modal>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { bugsnagClient } from "../lib/bugsnag";

export default {
    components: {
        Multiselect
    },

    name: "feed",

    props: {
        animal: {
            type: String,
            required: true
        },
        dietId: {
            default: ""
        },
        ingredientsArray: {
            default: [],
            required: true
        },
        diets: {
            default: () => {},
            required: true
        },
        dietaryPhytate: {
            default: ""
        }
    },

    data() {
        return {
            diet: {
                id: "",
                name: "",
                ingredients: [],
                edited: false
            },

            selectedDietId: this.dietId,
            selectedIngredients: [],
            totalPhytase: this.dietaryPhytate,
            productGroup: this.animal,
            step2View: "",
            showCreateDiet: false,
            showEditDiets: false,
            showDeleteModal: false,
            dietName: "",
            ingredientsDropdownHeight: 0
        };
    },

    watch: {
        diet: {
            handler: function(newDiet, oldDiet) {
                this.$emit("update:diet", { diet: newDiet });
            },
            deep: true
        },

        dietId: function(newId, oldId) {
            this.selectedDietId = newId;
            if (this.diets) this.diet = this.diets[newId];
            if (oldId === undefined || oldId === "") {
                this.dietSelected();
            }
            if ((newId === undefined || newId === "") && oldId != "") {
                this.resetComponent();
            }
        },

        dietaryPhytate: function(newValue, oldValue) {
            this.totalPhytase = this.dietaryPhytate;
            if (
                (oldValue === undefined || oldValue === "") &&
                (this.dietId == "" || this.dietId == undefined)
            ) {
                this.step2View = "phytate";
            }
        }
    },

    mounted: function() {
        if (this.selectedDietId && this.selectedDietId != "") {
            this.dietSelected();
        } else if (this.dietaryPhytate != "") {
            this.step2View = "phytate";
        }
    },

    computed: {
        totalPctg: function() {
            if (this.diet.ingredients == null) {
                return 0;
            }
            return this.diet.ingredients.reduce(function(a, b) {
                return b["percentage"] == null || b["percentage"] == ""
                    ? Number.parseFloat(a)
                    : Number.parseFloat(a) + Number.parseFloat(b["percentage"]);
            }, 0);
        },
        roundedPhytate: function() {
            return _.round(this.totalPhytase, 3);
        },
        ingredients: function() {
            return _.chain(this.ingredientsArray)
                .groupBy("category")
                .map((options, category) => ({ options, category }))
                .value();
        }
    },

    methods: {
        handleSaveDiet() {
            EventHub.$emit("saveDiet");
        },

        scrollToId(elId) {
            this.$scrollTo(`#${elId}`, 1000, { easing: "ease-in-out" });
        },

        addRow() {
            var newRow = {
                name: "Select ingredient",
                id: 0,
                editable: true,
                percentage: 0.0
            };
            this.diet.ingredients.push(newRow);
        },
        pushIngredientToDiet: function(row, event) {
            row.editable = false;
            row.id = event.target.selectedIndex;
            this.diet.edited = true;
        },
        ingredientInclusionEntered: function(row, event) {
            var keys = [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "0",
                ".",
                ",",
                "Backspace"
            ];

            if (keys.includes(event.key)) {
                this.diet.edited = true;
                this.calculatePhytase();
            }
        },

        calculatePhytase: _.debounce(function() {
            var self = this;
            axios
                .post("/calculatePhytase", {
                    diet: self.diet.ingredients
                })
                .then(response => {
                    self.totalPhytase = _.round(response.data.totalPhytase, 3);
                    self.$emit("update:phytate", {
                        phytate: self.totalPhytase
                    });
                })
                .catch(error => {
                    self.$toasted.global.calc_error({
                        error
                    });
                    if (error.response.status == 419) {
                        this.$router.push("/login");
                        location.reload();
                    }
                    bugsnagClient.notify(error);
                });
        }, 300),

        removeZero: function(row) {
            if (row.percentage == 0) {
                row.percentage = "";
            }
        },

        addZero: function(row) {
            if (row.percentage == "") {
                row.percentage = 0;
            }
        },

        ingredientSelected: function(ingredient, event) {
            if (event.target.checked) {
                ingredient.selected = true;
                // var newRow = {
                //     name: ingredient.name,
                //     id: ingredient.id,
                //     editable: false,
                //     pctg: 0.00
                // };
                // this.diet.push(newRow);
            } else {
                ingredient.selected = false;
                // this.diet = this.diet.filter(function(i) {
                //     return i.id !== ingredient.id;
                // });
            }
        },

        dietSelected: function() {
            var self = this;
            this.diet = this.diets[this.selectedDietId];
            this.$emit("update:diet", {
                diet: this.diet
            });
            if (
                !_.isNull(this.diet.ingredients) &&
                !_.isEmpty(this.diet.ingredients)
            ) {
                axios
                    .post("/calculatePhytase", {
                        productGroup: self.animal,
                        diet: self.diet.ingredients
                    })
                    .then(response => {
                        self.totalPhytase = _.round(
                            response.data.totalPhytase,
                            3
                        );
                        self.$emit("update:phytate", {
                            phytate: response.data.totalPhytase
                        });
                    })
                    .catch(error => {
                        self.$toasted.global.calc_error({
                            error
                        });
                        if (error.response.status == 419) {
                            this.$router.push("/login");
                            location.reload();
                        }
                        bugsnagClient.notify(error);
                    });
            } else {
                this.totalPhytase = 0;
                this.$emit("update:phytate", {
                    phytate: this.totalPhytase
                });
            }
            this.showModal = false;
            this.step2View = "diet";
            this.$emit("phytateValueManual", false);
        },

        createLocalDiet: function() {
            this.diet = {
                id: "",
                name: this.dietName
                    ? this.dietName
                    : `Diet ${this.findLatestId()}`,
                productGroup: this.animal,
                edited: true,
                ingredients: this.selectedIngredients.map(ingredient => ({
                    ...ingredient,
                    editable: false,
                    percentage: 0.0
                }))
            };

            //Find latest temp id
            let tempDietIds = _.chain(this.diets)
                .keys()
                .filter(id => id.includes("temp"))
                .map(id => _.split(id, "-", 2)[1])
                .values();
            let newId = `temp-${(_.max(tempDietIds) || 0) + 1}`;
            this.diet.id = newId;
            this.$emit("addItemToDiets", this.diet);
            this.selectedDietId = newId;
            this.totalPhytase = "";
            this.showCreateDiet = false;
            this.resetModal();
            this.step2View = "diet";
            this.$emit("phytateValueManual", false);
        },

        findLatestId() {
            let tempDietIds = _.chain(this.diets)
                .keys()
                .filter(id => _.isNumber(id))
                .values();
            return (_.max(tempDietIds) || 0) + 1;
        },

        resetModal() {
            this.dietName = "";
            this.selectedIngredients = [];
        },

        resetComponent() {
            this.resetDiet();
            this.step2View = "";
        },

        resetDiet() {
            this.selectedDietId = "";
            this.diet = {
                id: "",
                name: "",
                ingredients: []
            };
            this.$emit("update:diet", {
                diet: this.diet
            });
            this.totalPhytase = 0;
            this.$emit("update:phytate", {
                phytate: this.totalPhytase
            });
        },

        deleteDiet() {
            var self = this;
            if (_.toString(self.diet.id).includes("temp")) {
                this.$emit("deleteLocalDiet", { dietId: self.diet.id });
                self.resetComponent();
                self.$toasted.global.calc_success({
                    mainMessage: `Diet ${self.diet.name} deleted successfully!`
                });
                return;
            }
            axios
                .post("/deleteDiet", {
                    diet: self.diet
                })
                .then(response => {
                    this.$emit("update:diets", response.data.diets);
                    self.resetComponent();
                    self.$toasted.global.calc_success({
                        mainMessage: `Diet ${
                            self.diet.name
                        } deleted successfully!`
                    });
                })
                .catch(error => {
                    self.$toasted.global.calc_error({
                        error,
                        additionalMessage: `Diet '${
                            self.diet.name
                        }' could not be deleted`
                    });
                    bugsnagClient.notify(error);
                    if (error.response.status == 419) {
                        this.$router.push("/login");
                        location.reload();
                    }
                });
        },

        usePhytateValue() {
            this.step2View = "phytate";
            this.resetDiet();
            this.$emit('phytateValueManual', true);
        }
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
table td {
    vertical-align: middle !important;
}

table tr:hover td {
    background-color: inherit;
    opacity: 1;
    border-radius: 7px;
}

.borderRight {
    border-right: solid 2px white;
}

#dietTable {
    margin-bottom: 0;
}

#firstStep {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.customSection {
    padding: 1.3rem !important;
    border-top: 1px solid #dbdbdb;
    border-bottom: 1px solid #dbdbdb;
    background-color: white;
}

.field-label-30 {
    flex: 0 0 30%;
    text-align: center;
}

.scrollableTableWrapper {
    overflow-y: auto;
    height: 216px;
}

.scrollableTableWrapper td a {
    display: block;
    width: 100%;
}
</style>